(() => {
  if (customElements.get('pp-guide-video')) return;
  customElements.define('pp-guide-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button || this.cleanup) return;
      const video = this.video;
      const signal = new AbortController();
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manual = null;
      this.visible = false;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      const updateButton = () => {
        const paused = video.paused;
        this.button.setAttribute('aria-label', paused ? 'Afspil video' : 'Sæt video på pause');
        this.button.setAttribute('title', paused ? 'Afspil video' : 'Sæt video på pause');
        this.button.querySelector('[data-play]').toggleAttribute('hidden', !paused);
        this.button.querySelector('[data-pause]').toggleAttribute('hidden', paused);
      };
      const loadMedia = () => {
        if (video.dataset.poster) {
          video.poster = video.dataset.poster;
          delete video.dataset.poster;
        }
        if (this.loaded) return;
        this.loaded = true;
        this.querySelectorAll('[data-src]').forEach(source => {
          source.setAttribute('src', source.dataset.src);
          delete source.dataset.src;
        });
        video.preload = 'metadata';
        video.load();
      };
      const sync = () => {
        const allowed = this.manual === true || (this.manual === null && !motion.matches && !navigator.connection?.saveData);
        if (allowed && this.visible && !document.hidden) {
          loadMedia();
          video.play().catch(updateButton);
        } else video.pause();
      };
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        this.manual = video.paused;
        sync();
      }, { signal: signal.signal });
      video.addEventListener('play', updateButton, { signal: signal.signal });
      video.addEventListener('pause', updateButton, { signal: signal.signal });
      video.addEventListener('playing', updateButton, { signal: signal.signal });
      video.addEventListener('emptied', updateButton, { signal: signal.signal });
      document.addEventListener('visibilitychange', sync, { signal: signal.signal });
      motion.addEventListener('change', sync);
      const observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        sync();
      }, { threshold: 0 });
      const preloader = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) return;
        if (video.dataset.poster) {
          video.poster = video.dataset.poster;
          delete video.dataset.poster;
        }
        if (!motion.matches && !navigator.connection?.saveData && !document.hidden) loadMedia();
        preloader.disconnect();
      }, { rootMargin: '300px 0px' });
      preloader.observe(this);
      observer.observe(this);
      updateButton();
      this.cleanup = () => {
        observer.disconnect();
        preloader.disconnect();
        signal.abort();
        motion.removeEventListener('change', sync);
        video.pause();
      };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
})();
